// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N0H7","newExpiryDate":"styles_newExpiryDate__249jC","footer":"styles_footer__3LrnL"};